<template>
	<div class="vue-app">
		<!-- <p>Pinia Store: {{ storeData }}</p> -->
		<router-view />
	</div>
</template>

<script setup lang="ts">
// import { useProgramStore } from './stores/programStore';
// const storeData = useProgramStore();
</script>

<!-- app scoped styles -->
<style>
.vue-app {
	margin-bottom: 3rem;
}
</style>
